// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__8VbiD {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 38px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style: none;
  color: var(--color-font-10);
  background-color: var(--color-bg-footer);
  position: fixed;
  font-size: 12px;
  font-weight: 400;
  align-items: center;
}

.Footer_footer_text__8UQc0 {
  font-size: 12px;
  padding-left: 30px;
  min-width: 550px;
}

.Footer_footer_text__8UQc0 p {
  font-size: 12px;
}

.Footer_footer__8VbiD li {
  padding: 10px;
}

.Footer_footer_links_container__sW3ey {
  display: flex;
  flex-direction: row;
  padding-right: 20px;
  padding-left: 80px;
  min-width: 160px;
}

.Footer_footer_links__oSJop {
  text-decoration: none;
  color: var(--color-theme-10);
}

.Footer_footer_links__oSJop:hover {
  border-bottom: 1px solid var(--color-theme-2);
}
`, "",{"version":3,"sources":["webpack://./src/@_pages/Layout/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":[".footer {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 38px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  list-style: none;\n  color: var(--color-font-10);\n  background-color: var(--color-bg-footer);\n  position: fixed;\n  font-size: 12px;\n  font-weight: 400;\n  align-items: center;\n}\n\n.footer_text {\n  font-size: 12px;\n  padding-left: 30px;\n  min-width: 550px;\n}\n\n.footer_text p {\n  font-size: 12px;\n}\n\n.footer li {\n  padding: 10px;\n}\n\n.footer_links_container {\n  display: flex;\n  flex-direction: row;\n  padding-right: 20px;\n  padding-left: 80px;\n  min-width: 160px;\n}\n\n.footer_links {\n  text-decoration: none;\n  color: var(--color-theme-10);\n}\n\n.footer_links:hover {\n  border-bottom: 1px solid var(--color-theme-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__8VbiD`,
	"footer_text": `Footer_footer_text__8UQc0`,
	"footer_links_container": `Footer_footer_links_container__sW3ey`,
	"footer_links": `Footer_footer_links__oSJop`
};
export default ___CSS_LOADER_EXPORT___;
